import AnalyteModel from "@/models/lab/AnalyteModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * Analyte collection
 */
export default class AnalyteCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return AnalyteModel;
  }

}
